import _ from 'lodash';
import { isNavItemShown } from 'config/helpers';

import { Landing } from 'components/landing';
import App from 'components/IterioApp';

const coreComponents = [
  {
    transition: false,
    exact: false,
    path: '/console',
    component: App,
  }, {
    transition: false,
    exact: false,
    path: '/',
    component: Landing,
  },
];

export default _.filter(coreComponents, isNavItemShown);



// WEBPACK FOOTER //
// ./src/routes/RoutesComponent.js